import React from "react";

const UnAuthorised = () => {
  return (
    <div className="unauthorised-container page-height">
      <img
        src="/images/unauthorised-access.png"
        alt="unauthorised-access"
        height={300}
      />
      <h4 className="mt-4">Unauthorized Access</h4>
      <h5 className="mt-2" style={{ fontWeight: "normal" }}>
        You are not authorized to access this page.
      </h5>
    </div>
  );
};

export default UnAuthorised;
